<template>
    <div>
        <a-form layout="inline" class="mb-20">
            <a-form-item label="手机号">
                <a-input v-model="dataForm.phonenumber" placeholder="手机号搜索" />
            </a-form-item>
            <a-form-item>
                <a-button @click="getDataList" type="primary">查询</a-button>
            </a-form-item>
            <a-form-item v-permission="['admin:trip:groupphoneadd']">
                <a-button @click="addOrUpdateHandle()" type="primary">新增</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id" :loading="dataListLoading">
            <template slot="editBtn" slot-scope="text, row">
                <a-button type="link" @click="addOrUpdateHandle(row)" v-permission="['admin:trip:groupphoneadd2']">
                    编辑
                </a-button>
                <a-button type="link" @click="deleteHandle(row.subsId)" v-permission="['admin:trip:groupphonedelete']">
                    删除
                </a-button>
            </template>
        </a-table>
        <a-pagination size="small" class="mr-20 float-right" :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" :trip_id="trip_id" @ok="getDataList"></addorupdate>
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./addorupdateGroupphone.vue";
export default {
    components: { addorupdate },
    mixins: [viewModule],
    props: ["group_id", "pool_key", "trip_id"],
    data() {
        return {
            dataForm: {
                // group_id: this.group_id,
                trip_id: this.trip_id,
                phonenumber: "",
            },
            mixinViewModuleOptions: {
                getDataListURL: "/admin/trip/groupphonepage",
                deleteURL: "/admin/trip/groupphonedelete",
            },
            columns: [{
                title: "姓名",
                dataIndex: "nick_name",
                // width: 150,
            }, {
                title: "手机号",
                dataIndex: "phoneB",
                // width: 150,
            }, {
                title: "隐私号",
                dataIndex: "phoneNoX",
                // width: 150,
            }, {
                title: "过期时间",
                dataIndex: "expiration",
                // width: 150,
            }, {
                title: "状态",
                dataIndex: "status",
                customRender: (text, row) => {
                    if (text == 1) {
                        return '正常'
                    } else if (text == 0) {
                        return '过期'
                    } else {
                        return '未知'
                    }
                },
                // width: 150,
            }, {
                title: "操作",
                scopedSlots: { customRender: "editBtn" },
                // width: 150,
            }],
        };
    },
    methods: {
        deleteHandle(subsId) {
            this.$http({
                url: '/admin/trip/groupphonedelete',
                method: 'post',
                data: {
                    subsId,
                },
            }).then(() => {
                this.$message.success('删除成功');
                this.getDataList();
            })
        }
    }
};
</script>

<style></style>